import { useQuery } from '@tanstack/react-query';
import parseHtmlToReact from 'html-react-parser';
import { memo, useMemo } from 'react';

import BoxPrice from './BoxPrice';
import ArticleHeader from './Header';

import { resolvePathUrl } from '@cobalt/utilities';
import { getEditorialByIdQuery } from '@queries/editorial';
import PictureHelper from '@shared/PictureHelper';
import GoogleTagManagerHelper from '@tracking/gtm-helper';

import * as css from './styles.module.scss';

const HospitalityCategoryPackage = ({ articleId }: { articleId: string }) => {
  const { data: article } = useQuery({
    ...getEditorialByIdQuery(articleId),
    enabled: !!articleId,
  });

  const handleClick = () => {
    GoogleTagManagerHelper.event(
      'Click',
      'Apply',
      'hospitality',
      { interaction: 'Apply', section_reference: 'hospitality' },
      'hospitality_apply',
    );
  };
  const imgUrl = useMemo(() => {
    if (!article) return '';
    const url = article.document.content
      .filter((o) => o._type === 'FREE-PHOTO')
      .at(0)
      .figure.at(0)
      .img.at(0).src;
    return resolvePathUrl(url, 'free1');
  }, [article]);

  if (!article) return null;

  return (
    <div className={css.categoryBox}>
      <ArticleHeader title={article.title} summary={article.description} />
      <div className={css.article}>
        <div className={css.content}>
          <div className={css.imageWrapper}>
            <PictureHelper formats={['0@f']} imageUrl={imgUrl} title={article.title} />
          </div>
          <div className={css.table}>
            {article.document.content.filter((o) => o._type === 'TABLE').map((p) => parseHtmlToReact(p._html))}
          </div>
        </div>
        <div className={css.footer}>
          <BoxPrice article={article} onButtonClick={handleClick} />
        </div>
      </div>
    </div>
  );
};

export default memo(HospitalityCategoryPackage);
